import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ViewAgendaProps = IconComponentBaseProps;

export const ViewAgenda = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: ViewAgendaProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_10823_75863"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10823_75863)">
        <path
          d="M4.42312 9.00643C4.00215 9.00643 3.64583 8.8606 3.35416 8.56893C3.0625 8.27726 2.91666 7.92094 2.91666 7.49997V4.67955C2.91666 4.25858 3.0625 3.90226 3.35416 3.6106C3.64583 3.31893 4.00215 3.1731 4.42312 3.1731H15.5769C15.9978 3.1731 16.3542 3.31893 16.6458 3.6106C16.9375 3.90226 17.0833 4.25858 17.0833 4.67955V7.49997C17.0833 7.92094 16.9375 8.27726 16.6458 8.56893C16.3542 8.8606 15.9978 9.00643 15.5769 9.00643H4.42312ZM4.42312 7.75643H15.5769C15.641 7.75643 15.6998 7.72969 15.7531 7.67622C15.8066 7.62289 15.8333 7.56414 15.8333 7.49997V4.67955C15.8333 4.61539 15.8066 4.55664 15.7531 4.5033C15.6998 4.44983 15.641 4.4231 15.5769 4.4231H4.42312C4.35896 4.4231 4.30021 4.44983 4.24687 4.5033C4.1934 4.55664 4.16666 4.61539 4.16666 4.67955V7.49997C4.16666 7.56414 4.1934 7.62289 4.24687 7.67622C4.30021 7.72969 4.35896 7.75643 4.42312 7.75643ZM4.42312 16.8268C4.00215 16.8268 3.64583 16.681 3.35416 16.3893C3.0625 16.0977 2.91666 15.7414 2.91666 15.3204V12.5C2.91666 12.079 3.0625 11.7227 3.35416 11.431C3.64583 11.1393 4.00215 10.9935 4.42312 10.9935H15.5769C15.9978 10.9935 16.3542 11.1393 16.6458 11.431C16.9375 11.7227 17.0833 12.079 17.0833 12.5V15.3204C17.0833 15.7414 16.9375 16.0977 16.6458 16.3893C16.3542 16.681 15.9978 16.8268 15.5769 16.8268H4.42312ZM4.42312 15.5768H15.5769C15.641 15.5768 15.6998 15.5501 15.7531 15.4966C15.8066 15.4433 15.8333 15.3846 15.8333 15.3204V12.5C15.8333 12.4358 15.8066 12.3771 15.7531 12.3237C15.6998 12.2702 15.641 12.2435 15.5769 12.2435H4.42312C4.35896 12.2435 4.30021 12.2702 4.24687 12.3237C4.1934 12.3771 4.16666 12.4358 4.16666 12.5V15.3204C4.16666 15.3846 4.1934 15.4433 4.24687 15.4966C4.30021 15.5501 4.35896 15.5768 4.42312 15.5768Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
